module.exports = __webpack_public_path__ + "img/cui_lahore.fc7dfeb6.png";